<script>
import { nextTick } from 'vue'
import flatpickr from 'flatpickr'
import { Czech } from "flatpickr/dist/l10n/cs.js"
import { default as English } from "flatpickr/dist/l10n/default.js"
import { Polish } from "flatpickr/dist/l10n/pl.js"

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

import apiCustomers from '@/api/api-customers.js'

import MessageBoxQuestion from '../common/MessageBoxQuestion.vue'

export default {
    name: 'SensorFormComponent',

    components: {
        MessageBoxQuestion
    },

    props: {
        userLanguage: {
            type: String,
            default: 'cz'
        },
        languageStrings: {
            type: Object,
            default: null
        },
        sensorsList: {
            type: Array,
            default: () => []
        },
        editSensor: {
            type: Object,
            default: null
        },
        role: {
            type: Number,
            default: 0
        }
    },

    emits: ['form-closed'],

    data() {
        return {
            sensor: this.editSensor != null 
                ? { id: this.editSensor.id, serialNumber: this.editSensor.serialNumber, name: this.editSensor.name, customer: { id: this.editSensor.customer.id, name: '' }, machine: { id: this.editSensor.machine.id, name: '' }, validFrom: this.editSensor.validFrom, validTo: this.editSensor.validTo, registerSet: this.editSensor.registerSet }
                : { id: -1, serialNumber: '', name: '', customer: { id: -1, name: '' }, machine: { id: -1, name: '' }, validFrom: null, validTo: null },
            selectedSensor: -1,
            title: '',
            machines: [],

            errors: {
                serialNumber: false,
                machine: false,
                validFrom: false
            },

            fpValidFrom: null,
            fpValidTo: null,
            
            showSaveQuestion: false
        }
    },

    watch: {
        selectedSensor: async function() {
            if (this.selectedSensor == -1) {
                this.sensor.serialNumber = ''
                this.sensor.customer.id = -1
                this.sensor.machine.id = -1
                this.sensor.validFrom = null
                this.sensor.validTo = null
                this.sensor.registerSet = null

                this.fpValidFrom.set("minDate", null)
                this.fpValidTo.set("minDate", null)
                this.fpValidFrom.set("maxDate", null)
                this.fpValidTo.set("maxDate", null)
            }
            else {
                let s = this.sensorsList.find(a => a.id === this.selectedSensor)
                this.sensor.serialNumber = s.serialNumber
                this.sensor.customer.id = s.customer.id
                this.sensor.registerSet = s

                this.fpValidFrom.set("minDate", dayjs(s.validFrom + 'Z').utcOffset(0).format('YYYY-MM-DDTHH:mm:00'))
                this.fpValidTo.set("minDate", dayjs(s.validFrom + 'Z').utcOffset(0).format('YYYY-MM-DDTHH:mm:00'))
                if (s.validTo != null) {
                    this.fpValidFrom.set("maxDate", dayjs(s.validTo + 'Z').utcOffset(0).format('YYYY-MM-DDTHH:mm:00'))
                    this.fpValidTo.set("maxDate", dayjs(s.validTo + 'Z').utcOffset(0).format('YYYY-MM-DDTHH:mm:00'))
                }

                let result = await apiCustomers.getMachines(s.customer.id)
                if (result.code === 0) {
                    this.machines = result.data.slice().sort((a, b) => (a.name + ' (' + a.folder.name + ')').localeCompare((b.name + ' (' + b.folder.name + ')')))
                }
            }
        }
    },

    async mounted() {
        this.title = this.sensor.id === -1
            ? (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sensor010 != null ? this.languageStrings.ui.sensor010 : 'Nový senzor')
            : (this.languageStrings != null && this.languageStrings.ui != null && this.languageStrings.ui.sensor011 != null ? this.languageStrings.ui.sensor011 : 'Editace senzoru')

        if (this.sensor.validTo == null) this.sensor.validTo = null

        // if (this.editSensor != null) {
        //     let result = await apiCustomers.getMachines(this.sensor.customer.id)
        //     if (result.code === 0) {
        //         this.machines = result.data.slice().sort((a, b) => (a.name + ' (' + a.folder.name + ')').localeCompare((b.name + ' (' + b.folder.name + ')')))
        //     }

        //     if (this.sensor.id === -1) {
        //         this.sensor.validFrom = dayjs().format('YYYY-MM-DDTHH:mm:00')
        //     }
        // }

        if (this.userLanguage == 'pl') {
            flatpickr.localize(Polish)
        }
        else if (this.userLanguage == 'en') {
            English.firstDayOfWeek = 1
            English.time_24hr = true
            flatpickr.localize(English)
        }
        else {
            flatpickr.localize(Czech)
        }

        this.fpValidFrom = flatpickr('#valid-from',
        {
            enableTime: true,
            dateFormat: 'Y-m-dTH:i:S',
            altInput: true,
            altFormat: 'j.n.Y H:i',
            disableMobile: true,
            minuteIncrement: 1
        })

        this.fpValidTo = flatpickr('#valid-to',
        {
            enableTime: true,
            dateFormat: 'Y-m-dTH:i:S',
            altInput: true,
            altFormat: 'j.n.Y H:i',
            disableMobile: true,
            minuteIncrement: 1
        })

        if (this.editSensor != null) {
            let result = await apiCustomers.getMachines(this.sensor.customer.id)
            if (result.code === 0) {
                this.machines = result.data.slice().sort((a, b) => (a.name + ' (' + a.folder.name + ')').localeCompare((b.name + ' (' + b.folder.name + ')')))
            }

            if (this.sensor.id === -1) {
                this.sensor.validFrom = dayjs().format('YYYY-MM-DDTHH:mm:00')
                this.fpValidFrom.setDate(dayjs(this.sensor.validFrom + 'Z').utcOffset(0).format('YYYY-MM-DDTHH:mm:00'))

                this.sensor.validTo = null
                this.fpValidTo.setDate(dayjs(this.sensor.validTo + 'Z').utcOffset(0).format('YYYY-MM-DDTHH:mm:00'))
            }

            if (this.sensor.registerSet != null) {
                this.fpValidFrom.set("minDate", dayjs(this.sensor.registerSet.validFrom + 'Z').utcOffset(0).format('YYYY-MM-DDTHH:mm:00'))
                this.fpValidTo.set("minDate", dayjs(this.sensor.registerSet.validFrom + 'Z').utcOffset(0).format('YYYY-MM-DDTHH:mm:00'))
                if (this.sensor.registerSet.validTo != null) {
                    this.fpValidFrom.set("maxDate", dayjs(this.sensor.registerSet.validTo + 'Z').utcOffset(0).format('YYYY-MM-DDTHH:mm:00'))
                    this.fpValidTo.set("maxDate", dayjs(this.sensor.registerSet.validTo + 'Z').utcOffset(0).format('YYYY-MM-DDTHH:mm:00'))

                    if (this.sensor.id === -1) {
                        this.sensor.validTo = this.sensor.registerSet.validTo
                        this.fpValidTo.setDate(dayjs(this.sensor.registerSet.validTo + 'Z').utcOffset(0).format('YYYY-MM-DDTHH:mm:00'))
                    }
                }
            }
        }

        await nextTick()
        document.getElementById('editForm').focus()
    },

    methods: {
        formatDateTime(date) {
            return date !== null ? dayjs(date + 'Z').utcOffset(0).format('D.M.YYYY H:mm') : ''
        },
        handleFormKeyDown(event) {
            if (event.key === 'Escape') {
                this.closeForm()
            }

            if (event.key === 'Enter') {
                this.saveForm()
            }
        },
        closeForm() {
            this.$emit('form-closed', 1)
        },
        async saveForm() {
            let error = false
            if (this.sensor.serialNumber == null || this.sensor.serialNumber.length === 0) {
                this.errors.serialNumber = true
                error = true
            }
            else {
                this.errors.serialNumber = false
            }
            if (this.sensor.machine == null || this.sensor.machine.id == null || this.sensor.machine.id <= 0) {
                this.errors.machine = true
                error = true
            }
            else {
                this.errors.machine = false
            }
            if (this.sensor.validFrom == null || this.sensor.validFrom.length === 0) {
                this.errors.validFrom = true
                error = true
            }
            else {
                this.errors.validFrom = false
            }
            if (error) {
                return
            }

            this.showSaveQuestion = true
        },
        async messageBoxQuestionClosed(result) {
            this.showSaveQuestion = false

            if (result === 0) {
                if (this.sensor.validTo != null && this.sensor.validTo.length === 0) this.sensor.validTo = null
                this.$emit('form-closed', 0, this.sensor)
            }
            else {
                await nextTick()
                document.getElementById('editForm').focus()
                return
            }
        }
    }
}
</script>


<template>
    <div class="edit-form">
        <div id="editForm" @keydown="handleFormKeyDown" tabindex="-1">
            <span class="title">{{ title }}</span>
            <img src="@/assets/images/x.svg" @click="closeForm()" />

            <div class="edit-form-wrapper">
                <div class="edit-form-content">
                    <span v-show="editSensor == null" class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sensor013 != null ? languageStrings.ui.sensor013 : 'SN' }}</span>
                    <span v-show="editSensor == null">
                        <select :class="errors.serialNumber ? 'error' : ''" v-model.number="selectedSensor">
                            <option value="-1"></option>
                            <option v-for="s in sensorsList" :key="s.id" :value="s.id">{{ s.serialNumber + ' (' + s.customer.name + ')' + ' (' + (s.registerSet != null ? (this.formatDateTime(s.registerSet.validFrom) + ' - ' + (s.registerSet.validTo != null ? this.formatDateTime(s.registerSet.validTo) : '')) : (this.formatDateTime(s.validFrom) + ' - ' + (s.validTo != null ? this.formatDateTime(s.validTo) : ''))) + ')' }}</option>
                        </select>
                        <span class="color-red">&nbsp;*</span>
                    </span>

                    <span v-show="editSensor != null" class="first-column">
                        {{ 
                            role === 1 
                                ? languageStrings != null && languageStrings.ui != null && languageStrings.ui.sensor025 != null ? languageStrings.ui.sensor025 : 'Název'
                                : languageStrings != null && languageStrings.ui != null && languageStrings.ui.sensor013 != null ? languageStrings.ui.sensor013 : 'SN' 
                        }}
                    </span>
                    <span v-show="editSensor != null">
                        <input v-if="role === 1" type="text" v-model="sensor.name" autocomplete="off" disabled />
                        <input v-else type="text" v-model="sensor.serialNumber" autocomplete="off" disabled />
                    </span>

                    <span class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sensor021 != null ? languageStrings.ui.sensor021 : 'Stroj' }}</span>
                    <span>
                        <select :class="errors.machine ? 'error' : ''" v-model.number="sensor.machine.id">
                            <option value="-1"></option>
                            <option v-for="m in machines" :key="m.id" :value="m.id">{{ m.name + ' (' + m.folder.name + ')' }}</option>
                        </select>
                        <span class="color-red">&nbsp;*</span>
                    </span>

                    <span class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sensor016 != null ? languageStrings.ui.sensor016 : 'Platnost od' }}</span>
                    <span :class="errors.validFrom ? 'error' : ''">                    
                        <input type="text" id="valid-from" v-model="sensor.validFrom" autocomplete="off" />
                        <span class="color-red">&nbsp;*</span>
                    </span>

                    <span class="first-column">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.sensor017 != null ? languageStrings.ui.sensor017 : 'Platnost do' }}</span>
                    <span>                    
                        <input type="text" id="valid-to" v-model="sensor.validTo" autocomplete="off" />
                    </span>
                </div>

                <div class="edit-form-buttons">
                    <button class="button-small" @click="saveForm">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.form001 != null ? languageStrings.ui.form001 : 'Uložit' }}</button>
                    <button class="button-small" @click="closeForm">{{ languageStrings != null && languageStrings.ui != null && languageStrings.ui.form002 != null ? languageStrings.ui.form002 : 'Zrušit' }}</button>
                </div>
            </div>
        </div>
    </div>

    <MessageBoxQuestion v-if="showSaveQuestion" @form-closed="messageBoxQuestionClosed" :type="1"
        :text="languageStrings != null && languageStrings.ui != null && languageStrings.ui.sensor024 != null ? languageStrings.ui.sensor024 : 'Uložit senzor?'" 
        :yesButtonText="languageStrings != null && languageStrings.ui != null && languageStrings.ui.form003 != null ? languageStrings.ui.form003 : 'Ano'"
        :noButtonText="languageStrings != null && languageStrings.ui != null && languageStrings.ui.form004 != null ? languageStrings.ui.form004 : 'Ne'"
    />
</template>